export default __webpack_public_path__ + "media/d6628d57a00df88104db56893e4b937d5a9f229d52cffe44cb7a229476e80726.svg";